<template>
  <div class="info-main">
    <el-form
      class="page-form"
      :model="Business"
      label-position="left"
    >
      <p class="sub_t">Business</p>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item prop="BusinessName" label="Business Name">
            {{ Business.BusinessName || "--" }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="BusinessRegistrationNumber"
            label="Business Registration Number"
          >
            {{ Business.BusinessRegistrationNumber || "--" }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="JurisdictionOfIncorporation"
            label="Jurisdiction Of Incorporation"
          >
            {{ Business.JurisdictionOfIncorporation || "--" }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form
      class="page-form"
      :model="Location"
    >
      <p class="sub_t">Location</p>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item prop="City" label="City">
            {{ Location.City || "--" }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
           <el-form-item prop="PostalCode" label="Postal Code">
            {{ Location.PostalCode || "--" }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="Address1" label="Address 1 ">
            {{ Location.Address1 || "--" }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form
      class="page-form"
      :model="Communication"
      label-position="left"
    >
      <p class="sub_t">Communication</p>
      <el-row :gutter="40">
        <el-col :span="24">
          <el-form-item prop="Telephone" label="Telephone Number">
            {{ Communication.Telephone || "--" }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    Business: {
      type: Object,
      default: () => {
        return {};
      }
    },
    Location: {
      type: Object,
      default: () => {
        return {};
      }
    },
    Communication: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {
    };
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped lang="scss">
.info-main {
 padding:0 0.32rem;
}
.sub_t {
  font-size: 0.18rem;
  font-weight: bold;
}
</style>
